import { LanguagesEnum } from '@/api/enums/languages.enum';
import {
  ModifiedAnswerOption,
  ModifiedQuestion,
} from '@/client/quizzes/types/quizzes.type';

export const getTranslatedContent = (
  question: ModifiedQuestion | ModifiedAnswerOption | undefined,
  language: LanguagesEnum,
  field = 'text',
): string => {
  if (!question) return '';

  const translation = question.translations[language];
  if (!translation) {
    // Fallback to English if translation not available
    const englishTranslation = question.translations[LanguagesEnum.EN];
    if (!englishTranslation) return '';

    switch (field) {
      case 'text':
        return englishTranslation.text || '';
      case 'explanation':
        return englishTranslation.explanation || '';
      case 'placeholderText':
        return englishTranslation.placeholderText || '';
      case 'tooltipText':
        return englishTranslation.tooltipText || '';
      case 'scaleMinLabel':
        return englishTranslation.scaleMinLabel || '';
      case 'scaleMaxLabel':
        return englishTranslation.scaleMaxLabel || '';
      default:
        return '';
    }
  }

  switch (field) {
    case 'text':
      return translation.text || '';
    case 'explanation':
      return translation.explanation || '';
    case 'placeholderText':
      return translation.placeholderText || '';
    case 'tooltipText':
      return translation.tooltipText || '';
    case 'scaleMinLabel':
      return translation.scaleMinLabel || '';
    case 'scaleMaxLabel':
      return translation.scaleMaxLabel || '';
    default:
      return '';
  }
};
